import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import ReactTable from 'react-table';

import { Container, Button } from 'reactstrap';

import { playerActions } from '../../../actions';
import { getAllPlayers } from '../../../selectors';

class AdminViewRoster extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            players: [],
            loading: true
        }
    }

    componentDidMount(){
        this.setState({ loading: true });
        this.props.fetchPlayers(this.props.match.params.id);

        if(this.state.players.length > 0){
            this.setState({ loading: false });
        }

    }

    printData = () =>
    {
        let playerData = this.state.players.map((player) => {
            let isGoalie = player.isGoalie ? 'Yes' : 'No';
            let team = "";
            if(player.team >= 0 && player.team !== null){
                team = player.team === 0 ? 'White' : 'Black';
            }
            return `<tr><td>${player.firstName} ${player.lastName}</td><td>${player.email}</td><td>${team}</td><td>${isGoalie}</td></tr>`;
        });

        let printHTML = `
            <style>
                table, th, td {
                    border: 1px solid black;
                    border-collapse: collapse;
                }
            </style>
            <table style="width: 100%; text-align: center;">
                <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Team</th>
                    <th>Goalie</th>
                </tr>
                ${playerData}
            </table>`;


        const pri = document.getElementById("ifmcontentstoprint").contentWindow;
        pri.document.open();
        pri.document.write(printHTML);
        pri.document.close();
        pri.focus();
        pri.print();

    }

    change = (player, event) => {
        // Convert string to bool
        let team = event.target.value;
        if(team === "true"){
            team = true;
        }
        else if(team === "false"){
            team = false;
        } else {
            team = null;
        }

        this.props.editPlayerTeam(player.gameId, player.userId, team);
    }

    componentDidUpdate(prevProps){
        if(prevProps.players !== this.props.players){
            this.setState({ players: this.props.players });
            this.setState({ loading: false });
        }
    }

    render(){
        const columns = [ {
            id: 'team',
            Header: 'Team',
            accessor: g => {
                let team = g.team;
                if(g.team !== 0 && g.team !== 1 && g.team !== true && g.team !== false){
                    team = "";
                }
                return (
                    <select onChange={this.change.bind(this, g)} value={team}>
                        <option value="">---- Select Team ----</option>
                        <option value="false">White</option>
                        <option value="true">Black</option>
                    </select>
                );
            },
            sortMethod: (a, b) => {
                let aValue = a.props.value;
                let bValue = b.props.value;
                return aValue > bValue ? 1 : -1;
            },
            minWidth: 60
        }, {
            id: 'name',
            Header: 'Name',
            accessor: u => {
                return `${u.firstName} ${u.lastName}`;
            }
        }, {
            id: 'email',
            Header: 'Email',
            accessor: g => {
                return g.email;
            }
        }, {
            id: 'isGoalie',
            Header: 'Goalie',
            accessor: g => {
                return g.isGoalie ? 'Yes' : 'No';
            }
        }];

        const { players, loading } = this.state;
        return (
            <Container>
                <iframe id="ifmcontentstoprint" title='printframe' style={{height: "0px", width: "0px", position: "absolute"}}></iframe>

                <div className="mb3 mt3">
                    <ReactTable
                        data={players}
                        columns={columns}
                        defaultPageSize={25}
                        loading={loading}
                        className="playerChart"
                    />
                </div>
                <div className="" style={{width: '100%'}}>
                    <div className="fr mb3">
                        <Button className="mr2" color="primary" onClick={this.printData}>Print</Button>
                        <Link to='/admin/'>Cancel</Link>
                    </div>
                </div>
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        players: getAllPlayers(state)
    }
}

export default connect(mapStateToProps, playerActions)(AdminViewRoster);


// WEBPACK FOOTER //
// ./src/components/Admin/Games/AdminViewRoster.js